<script lang="ts">
  import ActionButton from '../ActionButton.svelte';
  import { theme, toggleTheme } from '~/theme/darkMode.svelte';
  import MoonIcon from '~icons/feather/moon';
  import SunIcon from '~icons/feather/sun';
</script>

<ActionButton onClick={toggleTheme} iconOnly>
  {#if theme.current === 'dark'}
    <SunIcon />
  {:else}
    <MoonIcon />
  {/if}
</ActionButton>
